import React from 'react';

import LabelStyles from '../../../shared/label-style';

import {Container} from './styles';

export type ZUIRadioButton = (props: {
  checked?: boolean;
  testId?: string;
  disabled?: boolean;
  checkHandler: (value: string) => void;
  value: string;
  label?: string;
  id?: string;
  name: string;
  className?: string;
  onClick?: () => void;
}) => React.ReactElement;

const RadioButton: ZUIRadioButton = ({
  checkHandler,
  value,
  testId,
  checked,
  disabled,
  label,
  id,
  className,
  name,
  onClick,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    checkHandler(event.target.value);
  };

  return (
    <Container className={className} disabled={disabled}>
      {label?.length ? (
        <LabelStyles htmlFor={id || label}>{label}</LabelStyles>
      ) : (
        <LabelStyles htmlFor={id} className="visually-hidden">
          RadioButton
        </LabelStyles>
      )}
      <input
        id={id || label}
        aria-label={label}
        type="radio"
        name={name}
        data-testid={testId}
        value={value}
        checked={checked}
        onChange={handleChange}
        onClick={onClick}
        className={`${className}_input`}
      />
    </Container>
  );
};
export default RadioButton;
